import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { TicketDesignUsage, TicketDesign } from "../../../models";
import { UnsafeAction } from "../../../actions/UnsafeAction";

/* tslint:disable */
@Injectable()
export class TicketDesignActions {

/*	static UPLOAD_TICKET_DESIGN = "[TICKET DESIGN] Upload TicketDesign"
	public uploadTicketDesign(file: File): Action {
		return {
			type: TicketDesignActions.UPLOAD_TICKET_DESIGN,
			payload: file
		}
	}*/

	static LOAD_TICKET_DESIGN_USAGES_BY_EVENT_UUID = "[Ticket Design] Load ticket design usages by event uuid"
	public loadTicketDesignUsagesByEventUuid(eventUuid: string): UnsafeAction {
		return {
			type: TicketDesignActions.LOAD_TICKET_DESIGN_USAGES_BY_EVENT_UUID,
			payload: eventUuid
		}
	}

	static TICKET_DESIGN_USAGES_BY_EVENT_UUID_LOADED = "[Ticket Design] ticket design usages loaded by event uuid"
	public ticketDesignUsagesByEventUuidLoaded(ticketDesignUsages: TicketDesignUsage[]): UnsafeAction {
		return {
			type: TicketDesignActions.TICKET_DESIGN_USAGES_BY_EVENT_UUID_LOADED,
			payload: ticketDesignUsages
		}
	}

	static TICKET_PREVIEW_IMAGE_LOADED = "[Ticket Design] ticket design preview image loaded"
	public ticketDesignPreviewImageLoaded(base64Preview: string, ticketDesignType: string): UnsafeAction {
		return {
			type: TicketDesignActions.TICKET_PREVIEW_IMAGE_LOADED,
			payload: { base64Preview: base64Preview, ticketDesignType: ticketDesignType }
		}
	}


	static UPLOAD_TICKET_DESIGN = "[Ticket Design] upload ticket design"
	public uploadTicketDesign(file: File, ticketDesignType: string): UnsafeAction {
		return {
			type: TicketDesignActions.UPLOAD_TICKET_DESIGN,
			payload: { file: file, ticketDesignType: ticketDesignType }
		}
	}

	static TICKET_DESIGN_UPLOADED = "[Ticket Design] ticket design uploaded"
	public ticketDesignUploaded(ticketDesign: TicketDesign, ticketDesignType: string): UnsafeAction {
		return {
			type: TicketDesignActions.TICKET_DESIGN_UPLOADED,
			payload: { ticketDesign: ticketDesign, ticketDesignType: ticketDesignType }
		}
	}

	static SAVE_TICKET_DESIGN_USAGE = "[Ticket Design] Save ticket design usage"
	public saveTicketDesignUsage(designUuid: string, eventUuid: string, ticketDesignType: string): UnsafeAction {
		return {
			type: TicketDesignActions.SAVE_TICKET_DESIGN_USAGE,
			payload: {designUuid: designUuid, eventUuid: eventUuid, ticketDesignType: ticketDesignType}
		}
	}

	static TICKET_DESIGN_USAGE_SAVED = "[Ticket Design] ticket design usage saved"
	public ticketDesignUsageSaved(ticketDesignUsage: TicketDesignUsage): UnsafeAction {
		return {
			type: TicketDesignActions.TICKET_DESIGN_USAGE_SAVED,
			payload: ticketDesignUsage
		}
	}

	static DELETE_TICKET_DESIGN_TICKET_PRINT = "[Ticket Design] Delete ticket design for ticket print"
	public deleteTicketDesignTicketPrint(ticketDesignUuid: string): UnsafeAction {
		return {
			type: TicketDesignActions.DELETE_TICKET_DESIGN_TICKET_PRINT,
			payload: ticketDesignUuid
		}
	}

	static TICKET_DESIGN_TICKET_PRINT_DELETED = '[Ticket Design] ticket design for ticket print deleted';
	public ticketDesignTicketPrintDeleted(): Action {
		return {
			type: TicketDesignActions.TICKET_DESIGN_TICKET_PRINT_DELETED
		}
	}

	static DELETE_TICKET_DESIGN_USAGE_TICKET_PRINT = "[Ticket Design] Delete ticket design usage for ticket print"
	public deleteTicketDesignUsageTicketPrint(ticketDesignUsageUuid: string): UnsafeAction {
		return {
			type: TicketDesignActions.DELETE_TICKET_DESIGN_USAGE_TICKET_PRINT,
			payload: ticketDesignUsageUuid
		}
	}

	static TICKET_DESIGN_USAGE_TICKET_PRINT_DELETED = '[Ticket Design] ticket design for ticket print usage deleted';
	public ticketDesignUsageTicketPrintDeleted():Action {
		return {
			type: TicketDesignActions.TICKET_DESIGN_USAGE_TICKET_PRINT_DELETED
		}
	}

	static DELETE_TICKET_DESIGN_PRINT_AT_HOME = "[Ticket Design] Delete print at home design"
	public deleteTicketDesignPrintAtHome(ticketDesignUuid: string): UnsafeAction {
		return {
			type: TicketDesignActions.DELETE_TICKET_DESIGN_PRINT_AT_HOME,
			payload: ticketDesignUuid
		}
	}

	static TICKET_DESIGN_PRINT_AT_HOME_DELETED = '[Ticket Design] ticket design for print at home deleted';
	public ticketDesignPrintAtHomeDeleted():Action {
		return {
			type: TicketDesignActions.TICKET_DESIGN_PRINT_AT_HOME_DELETED
		}
	}

	static DELETE_TICKET_DESIGN_USAGE_PRINT_AT_HOME = "[Ticket Design] Delete ticket design usage for print at home"
	public deleteTicketDesignUsagePrintAtHome(ticketDesignUsageUuid: string): UnsafeAction {
		return {
			type: TicketDesignActions.DELETE_TICKET_DESIGN_USAGE_PRINT_AT_HOME,
			payload: ticketDesignUsageUuid
		}
	}

	static TICKET_DESIGN_USAGE_PRINT_AT_HOME_DELETED = '[Ticket Design] ticket design usage for print at home deleted';
	public ticketDesignUsagePrintAtHomeDeleted():Action {
		return {
			type: TicketDesignActions.TICKET_DESIGN_USAGE_PRINT_AT_HOME_DELETED
		}
	}

	static UPLOAD_STATUS = '[Ticket Design] uploading ticket design'
	public uploadStatus(event: Event, ticketDesignType: string): UnsafeAction {
		return {
			type: TicketDesignActions.UPLOAD_STATUS,
			payload: { event: event, ticketDesignType: ticketDesignType }
		}
	}


	static SHOW_SPINNER = '[Ticket Design] show spinner'
	public showSpinner(): Action {
		return {
			type: TicketDesignActions.SHOW_SPINNER
		}
	}

	static HIDE_SPINNER = '[Ticket Design] hide spinner'
	public hideSpinner(): Action {
		return {
			type: TicketDesignActions.HIDE_SPINNER
		}
	 }

}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-designs/ticket-design.actions.ts